/**
 * @fileoverview Data model to hold the result from the Entity Selection step.
 *
 * @author Wyatt Lindquist (wlindquist@yext.com)
 */

export class EntitySelection {
  /**
   * @param {{
   *   savedFilterId: number,
   *   entityCount: number,
   *   displayName: string,
   * }} params
   */
  constructor(params) {
    /** @type {number} */
    this.savedFilterId = params.savedFilterId;
    /** @type {number} */
    this.entityCount = params.entityCount;
    /** @type {string} */
    this.displayName = params.displayName;
  }

  /**
   * @return {!EntitySelectionJson}
   */
  toJSON() {
    return {
      'savedFilterId': this.savedFilterId,
      'entityCount': this.entityCount,
      'displayName': this.displayName,
    };
  }
}

/**
 * @dict
 * @typedef {{
 *   savedFilterId: number,
 *   entityCount: number,
 *   displayName: string,
 * }}
 */
export let EntitySelectionJson;
